import { useMutation } from "react-query";

import {
  getLocalStorageItem,
  HIGHLIGHTED_APP_LOCATION_VIEW_COUNTS_KEY,
  setLocalStorageItem,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { CRMAppLocationIdentifier } from "../../types/Faq";
import { HighlightedAppLocationViewCounts } from "./getHighlightedAppLocationViews";

export const setHighlightedAppLocationView = (options: APQueryOptions = {}) => {
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [["highlighted-app-location-views"]];

  return useMutation({
    mutationFn: (appLocationIdentifier: CRMAppLocationIdentifier) => {
      const views: HighlightedAppLocationViewCounts =
        getLocalStorageItem<HighlightedAppLocationViewCounts>(
          HIGHLIGHTED_APP_LOCATION_VIEW_COUNTS_KEY
        ) || {};

      const viewCount = views[appLocationIdentifier];
      views[appLocationIdentifier] = viewCount ? viewCount + 1 : 1;

      setLocalStorageItem(HIGHLIGHTED_APP_LOCATION_VIEW_COUNTS_KEY, views);
      return Promise.resolve(true);
    },
    onError: defaultOnMutateError(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
